// extracted by mini-css-extract-plugin
export var brand = "_aj-9";
export var compact = "_aj-6";
export var extraSmall = "_aj-7";
export var icon = "_aj-0";
export var large = "_aj-4";
export var light = "_aj-1";
export var medium = "_aj-5";
export var outline = "_aj-b";
export var primaryDark = "_aj-a";
export var primaryLight = "_aj-8";
export var primaryModern = "_aj-c";
export var success = "_aj-2";
export var successSolid = "_aj-3";